import apolloClient from '@/api/apollo'

import VEHICLES_QUERY from '@/graphql/queries/Travels/Vehicles.graphql'
import EVENTS_QUERY from '@/graphql/queries/Travels/Events.graphql'

const module = {
  namespaced: true,
  state: {
    vehicles: [],
    events: []
  },
  getters: {
    fixedEvents: state => {
      const fixedEvents = []
      for (const event of state.events) {
        const latitude = event.data.gps.latitude
        const longitude = event.data.gps.longitude
        // Skip unfixed position
        if (!latitude || !longitude) {
          continue
        }
        fixedEvents.push(event)
      }
      return fixedEvents
      // Fake events
      // return [
      //   { _id: 'sdifgistdfiv', name: 'Reporte por tiempo', data: { gps: { latitude: 6.230818, longitude: -75.602143, date: new Date() } } },
      //   { _id: 'sdifgi44stdfiv', name: 'Desconexión de batería', data: { gps: { latitude: 6.231255, longitude: -75.597659, date: new Date() } } },
      //   { _id: 'sdifgis88tdfiv', name: 'Botón de pánico', data: { gps: { latitude: 6.231499, longitude: -75.588301, date: new Date() } } }
      // ]
    }
  },
  mutations: {
    setVehicles (state, vehicles) {
      state.vehicles = vehicles
    },
    setEvents (state, events) {
      state.events = events
    }
  },
  actions: {
    async fetchVehicles ({ commit }) {
      const result = await apolloClient.query({
        query: VEHICLES_QUERY
      })
      const vehicles = result.data.fetchVehicles
      commit('setVehicles', vehicles)
    },
    async fetchEvents ({ commit }, { vehicleId, startDate, finishDate }) {
      const result = await apolloClient.query({
        query: EVENTS_QUERY,
        variables: {
          vehicleId,
          startDate,
          finishDate
        }
      })
      const events = result.data.fetchEventsByVehicleAndDate
      commit('setEvents', events)
    }
  }
}

export default module



// WEBPACK FOOTER //
// ./src/store/modules/travels/index.js